export default __webpack_public_path__ + "static/media/icon-critical.5574927c.svg";